import request from 'api/requestUtils'
import config from 'constants/config'
import qs from 'qs'

interface GetMyCartsCart {
  transactionKey: string
  type: 'pending' | 'abandoned' | 'completed' | 'purchased'
  createdAt?: number
  updatedAt?: number
  brand?: string
  currency?: string
  total?: number
  rawItems: Array<App.Checkout.AnyItem>
}

interface GetMyCartsResponse {
  result: Array<GetMyCartsCart>
}

export type LatestRestorableCheckoutCart = App.SpoofUserCart

const RESTORABLE_CHECKOUT_CART_STATUSES: Array<GetMyCartsCart['type']> = ['pending', 'abandoned']
const LATEST_RESTORABLE_CHECKOUT_CART_QUERY = qs.stringify({
  brand: config.BRAND,
  page: 0,
  limit: 1,
  sortDir: 'DESC',
  statuses: RESTORABLE_CHECKOUT_CART_STATUSES,
}, { arrayFormat: 'brackets' })

function mapCheckoutCart(cart: GetMyCartsCart): LatestRestorableCheckoutCart {
  return {
    transactionKey: cart.transactionKey,
    type: cart.type,
    createdAt: cart.createdAt,
    updatedAt: cart.updatedAt,
    brand: cart.brand,
    currency: cart.currency,
    total: cart.total,
    rawItems: cart.rawItems,
  }
}

export async function getLatestRestorableCheckoutCart(): Promise<LatestRestorableCheckoutCart | undefined> {
  const response = await request.get<GetMyCartsResponse>(`/api/carts/me?${LATEST_RESTORABLE_CHECKOUT_CART_QUERY}`, {
    credentials: 'include',
    excludeBrand: true,
  })

  const cart = response.result.find(cart => RESTORABLE_CHECKOUT_CART_STATUSES.includes(cart.type))

  return cart ? mapCheckoutCart(cart) : undefined
}
